module.exports = __webpack_public_path__ + "media/S1E2_RetailVideo.5a69b1df.mp4";